import {
  userMyAuth,
  userItems,
  userItemsSearchAll,
  userOpen,
  userClose,
  userUnbundling,
  userDetails,
  userChangeAuth,
  adminChangePassword
} from '@/api/user'

const user = {
  state: {

  },
  mutations: {

  },
  actions: {
    UserMyAuth ({ commit }) {
      return new Promise((resolve, reject) => {
        userMyAuth().then(response => {
          commit('SET_AUTH', response.result.auth)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserItemsSearchAll ({ commit }) {
      return new Promise((resolve, reject) => {
        userItemsSearchAll().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserOpen ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userOpen(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserClose ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userClose(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserUnbundling ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userUnbundling(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserChangeAuth ({ commit }, data) {
      return new Promise((resolve, reject) => {
        userChangeAuth(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AdminChangePassword ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminChangePassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js